import { action } from 'satcheljs/lib/legacy';
import { ActionSource } from 'owa-mail-store';
import { composeStore } from 'owa-mail-compose-store';
import { lazyNewMessage } from 'owa-mail-message-actions';

// VSO 29687: Check if a new message is in the process of being created,
// and if not (or complete), create a new message
export default action('checkAndCreateNewMessage')(async function checkAndCreateNewMessage(
    actionSource: ActionSource,
    targetId: string
) {
    if (!composeStore.newMessageCreationInProgress) {
        composeStore.newMessageCreationInProgress = true;
        try {
            await lazyNewMessage.importAndExecute(actionSource, targetId);
        } finally {
            composeStore.newMessageCreationInProgress = false;
        }
    }
});
